import { DateTime } from "luxon";

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}

export function isUndefined<T>(value: T | null | undefined): value is undefined {
  return typeof value === "undefined";
}

export function isNonEmptyString(value: string | null | undefined) {
  return typeof value === "string" && value.length > 0;
}

export const dateBefore = (date: DateTime) => (value: string | null | undefined) => {
  return typeof value === "string" ? DateTime.fromISO(value) <= date : false;
};

export const dateAfter = (date: DateTime) => (value: string | null | undefined) => {
  return typeof value === "string" ? DateTime.fromISO(value) >= date : false;
};

export const dateBetween = (startDate: DateTime, endDate: DateTime) => (value: string | null | undefined) => {
  return typeof value === "string" ? dateAfter(startDate)(value) && dateBefore(endDate)(value) : false;
};
